import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";

import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import ClassNames from "classnames";

export default function ScoreOverwriteInput({
  onCheckChange = t => { },
  onTextChange = t => { },
  initialCheckedState,
  initialText,
  placeholderText,
  data,
  disabled,
  ...props
}) {
  const [checked, setChecked] = useState(
    initialCheckedState ? initialCheckedState : false
  );
  const [text, setText] = useState(initialText ? initialText : "");

  // trigger onchange callback on value change
  useEffect(() => {
    onCheckChange(checked);
  }, [checked]);

  // trigger onchange callback on value change
  useEffect(() => {
    onTextChange(text);
  }, [text]);

  return (
    <div
      className={ClassNames(
        styles.scoreOverwriteInput,
        checked ? styles.active : ""
      )}
    >
      <div className={styles.scoreOverwriteInputWrapper}>
        <div
          className={ClassNames(styles.header, checked ? styles.active : "")}
        >
          <Checkbox
            className={styles.checkbox}
            checked={checked}
            onChange={e => {
              setChecked(e.target.checked);
            }}
          />
          <div className={styles.label}>Overwrite with passing score</div>
        </div>
        {checked && (
          <div className={styles.textInput}>
            <TextField
              className={styles.textarea}
              multiline
              rows={4}
              variant="outlined"
              placeholder={placeholderText ? placeholderText : null}
              value={text}
              disabled={!!disabled}
              onChange={e => {
                setText(e.target.value);
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}
